import React from 'react';
import TextField from 'domains/core/components/TextField';

type PropType = {
    dataTestId?: string;
    disabled?: boolean;
    error?: boolean;
    helperText?: string;
    name: string;
    onChange: (event: any) => void;
    onClickAway?: () => void;
    withClickAway?: boolean;
    wrapperStyles?: any;
};

const ContentNameInput: React.FunctionComponent<PropType> = ({
    disabled = false,
    dataTestId,
    error,
    helperText,
    name,
    onChange,
    onClickAway,
    withClickAway,
    wrapperStyles,
}: PropType) => (
    <div style={{ padding: '8px 0', ...wrapperStyles }}>
        <TextField
            counterCurrent={name?.length ?? 0}
            counterMax={255}
            data-testid={dataTestId}
            disabled={disabled}
            error={error}
            helperText={helperText}
            label="Name"
            value={name}
            width="260px"
            withClickAway={withClickAway}
            withCounter
            onChange={onChange}
            {...{ onClickAway }}
        />
    </div>
);

export default ContentNameInput;
